import { IsNotEmpty, IsString, IsUUID, MaxLength } from 'class-validator';

export class RejectEventCommand {
  @IsNotEmpty()
  @IsUUID()
  id: string;

  @IsNotEmpty()
  @IsString()
  @MaxLength(255)
  message: string;
}
